import React from 'react'
import Scholarshipimg from '../assets/images/kfc-scholarship-img.png'
import Scholarshipchat from '../assets/images/chatscholarship.png'
import Education from '../assets/images/education.png'
import Diversity from '../assets/images/diversity.png'
import Influsion from '../assets/images/inclusion.png'
import Backet from '../assets/images/bucketimg.png'

const MitaoBhookscholarship = () => {
    return (
        <div>
            <div className='mt-16 w-full'>
                <img src={Scholarshipimg} alt="Child" className='w-full' />
            </div>
            <div className='flex items-center justify-center mt-16'>
                <div className='w-[65%]'>
                    <img src={Scholarshipchat} alt="Chat" className='w-full' />
                    <h1 className='md:text-xl lg:text-3xl mb-70  mx-auto text-center font-bold mt-10'>
                        KFC PAKISTANS MITAO BHOOK PLATFORM IS PROVIDING 120+ HIGHER <br />
                        EDUCATION SCHOLARSHIPS TO DESERVING STUDENTS ACROSS ALL HEC <br />
                        RECOGNISED INSTITUTES IN PAKISTAN. THIS IS DONE IN COLLABORATION WITH <br />
                        THE ORANGE TREE FOUNDATION, AN EDUCATION ADVOCATE WORKING TO <br />
                        FURTHER EDUCATION IN THE COUNTRY.
                    </h1>
                    <h1 className='md:text-xl lg:text-3xl mb-70 mx-auto text-center font-bold mt-10'>
                        HIGHER EDUCATION GIVES YOU, THE PAKISTANI YOUTH, AN OPPORTUNITY TO <br />
                        SUCCEED IN TODAY’S GLOBAL ECONOMY AND KFC PAKISTAN IS EXCITED TO <br />
                        ENABLE THE DREAMS OF HUNDREDS OF PAKISTANI SCHOLARS EMBARKING ON <br />
                        THIS JOURNEY.
                    </h1>
                    <div className='flex flex-wrap justify-center mt-16 space-x-6 lg:flex-nowrap md:flex-wrap'>
                        <img className='flex-none w-full md:w-[50%] lg:w-auto' src={Education} alt='education' />
                        <img className='flex-none w-full md:w-[50%] lg:w-auto' src={Diversity} alt='diversity' />
                        <img className='flex-none w-full md:w-[50%] lg:w-auto' src={Influsion} alt='Influsion' />
                    </div>
                </div>
            </div>
            <div className='flex flex-col items-center justify-center'>
                <img src={Backet} alt='backet' className='w-full mb-4' />
                <button className='bg-dark-secondary py-6 px-7 font-bold rounded-md'>
                    Apply Now
                </button>
            </div>
            <div className='items-center justify-center bg-white text-lg p-[90px] mt-9'>
                <h1 className='text-center font-bold text-5xl md:text-6xl lg:text-8xl'>
                    ELIGIBILITY CRITERIA
                </h1>
            </div>
            <div className="flex items-center justify-center">
                <ul className="mt-4 list-disc pl-6">
                    <li className="mb-4 text-xl font-bold mr-9">
                        Applicant must be a resident of Pakistan.
                    </li>
                    <li className="mb-4 text-xl font-bold mr-9">
                        Students need to compete for securing admission at the participating institution as per <br />
                        the admission policy of the institution and be enrolled in undergraduate (4 years) programs.
                    </li>
                    <li className="mb-4 text-xl font-bold mr-9">
                        Students in financial need who are already enrolled in participating institutions are also <br />
                        eligible to apply.
                    </li>
                    <li className="mb-4 text-xl font-bold mr-9">
                        Students in financial need who are already enrolled in participating institutions are also <br />
                        eligible to apply.
                    </li>
                </ul>
            </div>
            <div className='items-center justify-center bg-dark-secondary text-lg p-[90px] '>
                <h1 className='text-center font-bold text-7xl md:text-5xl lg:text-7xl sm:text-3xl'>
                    FIELDS SUPPORTED FOR THE SCHOLARSHIP
                </h1>
            </div>
            <div className='text-lg font-bold justify-center items-center'>
                <h1 className='text-2xl mb-4'>
                    Business, Engineering, Medical, IT, Mathematics, Physical Sciences, Education and More
                </h1>
                <h1 className='text-2xl mb-4'>
                    Please note these scholarships are provided yearly, and renewal for existing students will be contingent on the academic committee’s discretion every year.
                </h1>
                <h1 className='text-2xl mb-4'>
                    Complete policy document available here.
                </h1>
            </div>
            <div className='flex flex-col items-center justify-center'>
                <button className='bg-dark-secondary py-6 px-7 font-bold mb-7 rounded-md'>
                    Apply Now
                </button>
            </div>
        </div>
    )
}

export default MitaoBhookscholarship